export class SignatureConstant {
  static readonly SIGNATURE_COLOR = "SIGNATURE_COLOR";
  static readonly PNG = "PNG";
  static readonly PERSON_SIGN: string = "Person Signature"
  static readonly BASE64: string = "base64" + ",";
}
